import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatModule } from 'core/material/mat.module';
import { TranslationModule } from 'core/translation/translation.module';
import { PriceDisplayComponent } from './price-display.component';
import { PriceFormatPipe } from './price-format.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatModule,
    TranslationModule,
  ],
  declarations: [
    PriceDisplayComponent,
    PriceFormatPipe,
  ],
  exports: [
    PriceDisplayComponent,
    PriceFormatPipe,
  ],
})
export class PriceModule { }
